import { portNumbers } from "get-port"
// @ts-ignore
import { alto } from "prool/instances"
import {
  ENTRYPOINT_V07_ADDRESS,
  ENTRY_POINT_SIMULATIONS_ADDRESS
} from "./addresses"
import type { NetworkArgs } from "./toNetwork"
import { getFreePort } from "./utils"

export type Bundler = Awaited<ReturnType<typeof toBundler>>

export type ToBundlerParameters = NetworkArgs & { port?: number }
export const toBundler = async (parameters: ToBundlerParameters) => {
  const {
    rpcUrl,
    port = await getFreePort(5010, 5499),
    privateKey
  } = parameters
  const url = `http://127.0.0.1:${port}`

  const instance = alto({
    entrypoints: [ENTRYPOINT_V07_ADDRESS],
    entrypointSimulationContract: ENTRY_POINT_SIMULATIONS_ADDRESS,
    rpcUrl,
    utilityPrivateKey: privateKey,
    executorPrivateKeys: [privateKey],
    safeMode: false,
    port
  })

  await instance.start()

  // Now ensure the bundler is ready
  while (true) {
    try {
      const chainIdResponse = await fetch(url, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          method: "eth_chainId",
          params: [],
          id: Date.now(),
          jsonrpc: "2.0"
        }),
        method: "POST"
      })
      await chainIdResponse.json()
      return { instance, port, url }
    } catch {
      await new Promise((resolve) => setTimeout(resolve, 1000))
    }
  }
}
